(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('UserManagementResetController', UserManagementResetController);

    UserManagementResetController.$inject = ['$uibModalInstance', 'profilesPromise', 'History'];

    function UserManagementResetController ($uibModalInstance, profilesPromise, History) {
        var vm = this;
        profilesPromise.$promise.then(function (profiles) {
            vm.profileId = profiles.length ? profiles[0].id : null;
        });

        vm.clear = clear;
        vm.confirmReset = confirmReset;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReset(id) {
            History.resetProfile({ id: id },
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
